// Crisp 線上客服聊天窗（trade.masquant.com）。
//
// - 與官網共用「同一個」Crisp website（trade 自己的 free workspace 沒有 API 權限、token 無法認證，
//   故 trade 掛官網這個 website）；靠 session:data 打 source_site=trade_platform 標記，
//   後端 resolveSourceSite 讀它 → CRM 仍顯示「交易平台」，與官網分流。
// - 使用者登入後把 email / 暱稱帶進 Crisp → 客服一看就知道是哪個會員在問。
// - 未設 website ID 時不載入（no-op），不影響 build / 頁面。
import { useEffect } from "react";
import { useAuth } from "AuthContext";

// 官網那個 Crisp website ID（公開值，可寫死）。trade 與官網共用同一個 website。
const CRISP_WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID || "6b0afb70-7d94-476b-ba6a-8bd5213f9f7b";
// 站別標記：讓後端在 CRM 區分「交易平台」vs 官網
const SOURCE_SITE = "trade_platform";

export default function CrispChat() {
  const { user, isAuthenticated } = useAuth();

  // 載入 Crisp widget（只載一次）
  useEffect(() => {
    if (!CRISP_WEBSITE_ID) return; // 未設 → 不載入
    if (window.$crisp) return; // 已載入
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;
    // 標記這是交易平台來的對話（後端據此在 CRM 顯示「交易平台」）。
    //   打兩次確保牢靠：①初次排隊 ②session:loaded 後再補一次——
    //   避免「第一則訊息的 REST 回拉」比標記寫入還早（race）→ 被誤判成官網。
    const tagSource = () => window.$crisp.push(["set", "session:data", [[["source_site", SOURCE_SITE]]]]);
    tagSource();
    window.$crisp.push(["on", "session:loaded", tagSource]);
    const s = document.createElement("script");
    s.src = "https://client.crisp.chat/l.js";
    s.async = 1;
    document.getElementsByTagName("head")[0].appendChild(s);
  }, []);

  // 帶入 / 清除登入者身分
  useEffect(() => {
    if (!CRISP_WEBSITE_ID || !window.$crisp) return;
    if (isAuthenticated && user) {
      if (user.email) window.$crisp.push(["set", "user:email", [user.email]]);
      const nickname = user.fullName || user.name || user.email;
      if (nickname) window.$crisp.push(["set", "user:nickname", [nickname]]);
    } else {
      // 登出：重置 session，避免下一位沿用前一位的身分
      try {
        window.$crisp.push(["do", "session:reset"]);
      } catch (_) {
        /* widget 尚未就緒時忽略 */
      }
    }
  }, [isAuthenticated, user]);

  return null;
}
